import { axiosInstance } from '../../../common/axiosInstans';

export default class DeviationService {
    getDeviations = async (filter: 'inactive' | 'active') => {
        try {
            const res = await axiosInstance.get(
                filter === 'inactive'
                    ? '/deviationreport/inactive'
                    : '/deviationreport/active'
            );

            return res.data;
        } catch (error) {
            throw error;
        }
    };

    getDeviation = async (id: string) => {
        try {
            const response = await axiosInstance.get(`/deviationreport/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    setStatusDone = async (id: string, comment: string) => {
        try {
            const response = await axiosInstance.patch(
                `/deviationreport/done/${id}`,
                {
                    actionStatus: 2,
                    Id: id,
                    Comment: comment,
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    };
}
